import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import Swal from "sweetalert2";

const AddFormMetadataForm = ({ getStudyLevelForm }) => {
  const [formName, setFormName] = useState("");
  const [formLabel, setFormLabel] = useState("");
  const [formCode, setFormCode] = useState("");
  const [domainClassType, setDomainClassType] = useState("");
  const [domainCode, setDomainCode] = useState("");
  const [domainLabel, setDomainLabel] = useState("");
  const [formType, setFormType] = useState("");
  const [formRepeat, setFormRepeat] = useState("");
  const [specialForm, setSpecialForm] = useState("");
  const [customForm, setCustomForm] = useState("");
  const [unbliendForm, setUnbliendForm] = useState("");
  let { studyId } = useParams();
  const [haveJson, setHaveJson] = useState("no");
  const [formArray, setFormArray] = useState([]);
  const [addButtonLoader, setAddButtonLoader] = useState(false)
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const addNewStudyLevelForm = async () => {
    setAddButtonLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.formName = formName
    userData.formLabel = formLabel
    userData.formCode = formCode
    userData.domainClassType = domainClassType
    userData.domainCode = domainCode
    userData.domainLabel = domainLabel
    userData.formType = formType
    userData.formRepeat = formRepeat
    userData.specialForm = specialForm
    userData.customForm = customForm
    userData.unbliendForm = unbliendForm
    userData.category = LoginCat
    let data
    if (haveJson === "yes") {
      data = await studyLevelFormManagementServices.addNewStudyLevelFormWithFile(userData)
    } else {
      data = await studyLevelFormManagementServices.addNewStudyLevelForm(userData)
    }
    if (data?.statusCode === 200) {
      clearForm()
      getStudyLevelForm()
    }
    setAddButtonLoader(false)
  }

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/json') {
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const parsed = JSON.parse(event.target.result);
          if (Array.isArray(parsed)) {
            setFormArray(parsed);
          } else {
            Swal.fire({
              icon: 'error',
              title: "Error",
              text: "JSON is not an array.",
              showConfirmButton: false,
              timer: 1500
            })
          }
        } catch (err) {
          Swal.fire({
            icon: 'error',
            title: "Error",
            text: "Invalid JSON file.",
            showConfirmButton: false,
            timer: 1500
          })
        }
      };
      reader.readAsText(file);
    } else {
      Swal.fire({
        icon: 'error',
        title: "Error",
        text: "Please upload a valid JSON file.",
        showConfirmButton: false,
        timer: 1500
      })
    }
  };

  const clearForm = () => {
    setFormName("")
    setFormLabel("")
    setFormCode("")
    setDomainClassType("")
    setDomainCode("")
    setDomainLabel("")
    setFormType("")
    setFormRepeat("")
    setSpecialForm("")
    setCustomForm("")
    setUnbliendForm("")
  }

  useEffect(() => {
    clearForm();
  }, []);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form Name{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setFormName(e.target.value)}
          value={formName}
          className="br3"
          placeholder="Form Name"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form Label{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setFormLabel(e.target.value)}
          value={formLabel}
          className="br3"
          placeholder="Form Label"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form Code{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => {
            const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
            setFormCode(input);
          }}
          onKeyDown={(e) => {
            if (e.key === " ") {
              e.preventDefault();
            }
          }}
          value={formCode}
          className="br3"
          placeholder="Form Code"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Domain Class Type{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setDomainClassType(e.target.value)}
          value={domainClassType}
          className="br3"
          placeholder="Domain Class Type"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Domain Label{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setDomainLabel(e.target.value)}
          value={domainLabel}
          className="br3"
          placeholder="Domain Label"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Domain Code{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => {
            const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
            setDomainCode(input);
          }}
          onKeyDown={(e) => {
            if (e.key === " ") {
              e.preventDefault();
            }
          }}
          value={domainCode}
          className="br3"
          placeholder="Domain Code"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form Type{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setFormType(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={formType === ""} value="">Select Form Type</option>
          <option selected={formType === "regular"} value="regular">Regular</option>
          <option selected={formType === "log"} value="log">Log</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form Repeat{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setFormRepeat(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={formRepeat === ""} value="">Select Form Repeat</option>
          <option selected={formRepeat === "yes"} value="yes">Yes</option>
          <option selected={formRepeat === "no"} value="no">No</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Special Form{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setSpecialForm(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={specialForm === ""} value="">Select Special Form</option>
          <option selected={specialForm === "yes"} value="yes">Yes</option>
          <option selected={specialForm === "no"} value="no">No</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Custom Form{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setCustomForm(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={customForm === ""} value="">Select Custom Form</option>
          <option selected={customForm === "no"} value="no">No</option>
          <option selected={customForm === "tenderSwallen"} value="tenderSwallen">Tender/Swallen</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Unbliend Form{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setUnbliendForm(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={unbliendForm === ""} value="">Select Unbliend Form</option>
          <option selected={unbliendForm === "no"} value="no">No</option>
          <option selected={unbliendForm === "yes"} value="yes">Yes</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          You have Form Json Data{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setHaveJson(e.target.value)}
          style={{ fontSize: 12 }}
          className="br3"
        >
          <option selected={haveJson === ""} value="">Select Yes or No</option>
          <option selected={haveJson === "yes"} value="yes">Yes</option>
          <option selected={haveJson === "no"} value="no">No</option>
        </Form.Select>
      </Form.Group>
      {haveJson === "yes" &&
        <Form.Group className="mb-1">
          <Form.Label className="fw-bold mb-1">
            Upload Form File{" "}
            <abbr title="Required" className="text-danger">
              *
            </abbr>
          </Form.Label>
          <Form.Control
            onChange={(e) => handleFileUpload(e)}
            className="br3"
            type="file"
          />
        </Form.Group>
      }
      <div className="text-end">
        <button
          disabled={
            haveJson === "yes" ?
              formArray?.length === 0 || !formName || !formLabel || !formCode || !domainClassType || !domainCode || !domainLabel || !formType || !formRepeat || !specialForm || !unbliendForm || !customForm || addButtonLoader
              :
              !formName || !formLabel || !formCode || !domainClassType || !domainCode || !domainLabel || !formType || !formRepeat || !specialForm || !unbliendForm || !customForm || addButtonLoader
          }
          onClick={addNewStudyLevelForm}
          className="updateProfile"
        >
          {addButtonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm"/> Adding...
            </div>
          ) : (
            "Add Metadata"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddFormMetadataForm;
